
import './styles.scss';
import React, {Dispatch, useEffect, useState} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../../constants";
import {IMyLibraryMenuItem} from "./interface";

/* Bootstrap */
import {Nav, Navbar} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux";
import {AnyAction} from "@reduxjs/toolkit";
import {IMyLibraryState} from "../../../../types/redux/my-library";
import {setLibrarySection} from "../../../../redux/slices/my-library-slice";
import {clearFilters, searchReset, setFiltersKey} from "../../../../redux/slices/search-slice";
import {clearResults, resetResults} from "../../../../redux/slices/result-slice";

const MyLibraryMenu = ():JSX.Element => {
  const section: string | null = useSelector<RootState, IMyLibraryState>(state => state.my_library).section;
  const dispatch:Dispatch<AnyAction> = useDispatch();

  const [expanded, setExpanded] = useState<boolean>(false)
  const items: IMyLibraryMenuItem[] = Constants.MY_LIBRARY_MENU_ITEMS;

  useEffect(()=>{
    dispatch(searchReset());
    dispatch(clearResults());
    dispatch(clearFilters());

    if (section === Constants.MY_DOCUMENTS) {
      dispatch(setFiltersKey(Constants.TAGS))
    } else {
      dispatch(setFiltersKey(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  const handleItemClick = (e:React.MouseEvent, key: string | null):void => {
    e.preventDefault();
    if (key && (key !== section)) {
      setExpanded(false);
      dispatch(searchReset())
      dispatch(resetResults());
      dispatch(setLibrarySection(key));
    }
  }

  return (
    <div className={'my-library-menu'}>
      <Navbar className={'p-0 rounded-md-bottom'} expand="lg" expanded={expanded} onToggle={()=>setExpanded(!expanded)} >
        <div className={'subheader-container d-lg-none w-100'}>
          <Navbar.Toggle
            aria-controls={"industry-navbar"}
            className={'nav-toggle d-inline-block'}
          >
            <div className={'arrow-container'}>
              <div className={(expanded? 'arrow-up': 'arrow-down')}/>
            </div>
          </Navbar.Toggle>
        </div>

        <div className={'nav-container shadow-sm w-100'}>
          <Navbar.Collapse id={'my-library-navbar'}>
            <Nav className={'justify-content-left bg-white w-100 mb-0  position-relative shadow-sm'}>
              {items.map((item:IMyLibraryMenuItem, index:number) => {
                return (
                  <Nav.Item
                    role={'presentation'}
                    key={"sm-item"+index}>

                    <Nav.Link
                      className={'mx-4 py-2 px-0 text-black' + (section === item.section ? ' active': '')}
                      onMouseUp={e=>handleItemClick(e, item.section)}
                      role="tab"
                      eventKey={index}
                    >
                      {item.label}
                    </Nav.Link>
                    <div className={(section === item.section) ? 'active_select' : '' }/>
                  </Nav.Item>
                )
              })}
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </div>
  )
}

export default MyLibraryMenu;
